import React from "react";

const FeatureSection = ({ title, description, image, reverse = false }) => {
  return (
    <div className="container mb-5">
      <div className="col-12 d-flex justify-content-center">
        <div className="row feature-wrapper align-items-center feature-equal">

          {/* IMAGE */}
          <div
            className={`col-12 col-md-6 d-flex justify-content-center align-items-center card-border-right ${
              reverse ? "order-md-2 card-border-left" : ""
            }`}
          >
            <div className="image-card d-flex align-items-center justify-content-center">
              <img
                src={image || "https://via.placeholder.com/600x400"}
                alt="feature"
                className="img-fluid rounded"
              />
            </div>
          </div>

          {/* TEXT */}
          <div
            className={`col-12 col-md-6 d-flex flex-column justify-content-center ${
              reverse ? "order-md-1 text-md-start card-border-right text-left mt-4" : "text-md-start card-border-left text-left mt-4"
            }`}
          >
            <h2 className="fw800">{title}</h2>
            <p className="text-muted mt-3 font90x">{description}</p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FeatureSection;